import { Link } from "react-router-dom";

export default function Categories(props) {
  const fetchCategories = props.data.data.content.categories;
  return (
    <section className="categories">
      <ul className="categories-list">
        {fetchCategories.map((category) => (
          <li key={category.category} className="categories-item">
            <div className="categories-item-inner">
              <Link to={`/category/${category.category}`}>Link</Link>
              <span className="categories-item-inner-icon">
                <span
                  className="categories-item-inner-icon-color"
                  style={{ backgroundColor: category.color }}
                ></span>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/svg/${category.svg}`}
                  alt={category.title}
                />
              </span>
              <div className="categories-item-inner-title">
                {category.title}
              </div>
              <p className="categories-item-inner-description">
                {category.text}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
